import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { setImageLoading } from "areas/product/store/actions"
import Image from "components/ui/image"
import { cn } from "styles/utils"

import ImageLoader from "./image-loader"

const ProductImage = ({ className = "", sizes, src, srcSet, ...props }) => {
  const wizardLoading = useSelector((state) => state.wizard.loading)
  const imageLoading = useSelector((state) => state.previewImageUI.imageLoading)
  const [currentSrc, setCurrentSrc] = useState(src)
  const [currentSrcSet, setCurrentSrcSet] = useState(srcSet)
  const dispatch = useDispatch()

  useEffect(() => {
    const img = new window.Image()
    img.src = src
    if (sizes) img.sizes = sizes
    if (srcSet) img.srcset = srcSet

    let cancelled = false

    img.onload = () => {
      if (!cancelled) {
        setCurrentSrc(src)
        setCurrentSrcSet(srcSet)
        dispatch(setImageLoading(false))
      }
    }

    img.onerror = () => {
      if (!cancelled) {
        dispatch(setImageLoading(false))
      }
    }

    return () => {
      cancelled = true
      img.onload = null
      img.onerror = null
    }
  }, [src, srcSet, sizes])

  return (
    <>
      <Image
        className={cn(
          "tablet:max-w-(--tablet-max-width) desktop:max-w-(--desktop-max-width) mx-auto block h-auto w-full transition-opacity duration-300 ease-in-out",
          (wizardLoading || imageLoading) && "bg-white opacity-50",
          className
        )}
        sizes={sizes}
        src={currentSrc}
        srcSet={currentSrcSet}
        style={{
          "--desktop-max-width": "500px",
          "--tablet-max-width": "325px",
        }}
        {...props}
      />
      {(wizardLoading || imageLoading) && <ImageLoader />}
    </>
  )
}

ProductImage.propTypes = {
  className: PropTypes.string,
  sizes: PropTypes.string,
  src: PropTypes.string,
  srcSet: PropTypes.string,
}

export default ProductImage
